// Local Lenis helper for RockHallTv
// Keeps a section-scoped Lenis instance. autoRaf is disabled so callers
// can drive RAF (for example via gsap.ticker) and keep Lenis in sync with
// ScrollTrigger.

import Lenis from 'lenis';

let _lenis: Lenis | null = null;

const logStyle = 'color: cyan;';

export function getLenis(): Lenis | null {
  return _lenis;
}

export function startLenis(opts: Partial<ConstructorParameters<typeof Lenis>[0]> = {}) {
  if (typeof window === 'undefined') return null;
  if (!_lenis) {
    // console.log('%c[Lenis] Creating new Lenis instance', logStyle);
    _lenis = new Lenis({
      autoRaf: false,
      smooth: true,
      duration: 1.0,
      // default easing is linear here; consumer may override via opts
      easing: (t: number) => t,
      ...opts,
    } as any);
  }

  try {
    // start is safe to call multiple times in many versions of Lenis
    _lenis.start();
    // console.log('%c[Lenis] Started Lenis instance', logStyle);
  } catch (e) {
    // ignore
  }

  return _lenis;
}

export function stopLenis() {
  if (!_lenis) return;
  try {
    _lenis.stop();
    // console.log('%c[Lenis] Stopped Lenis instance', logStyle);
  } catch (e) {
    // ignore
  }

  // Try to call destroy() if it exists (newer versions of Lenis)
  try {
    if (typeof (_lenis as any).destroy === 'function') {
      (_lenis as any).destroy();
      // console.log('%c[Lenis] Destroyed Lenis instance', logStyle);
    }
  } catch (e) {
    // ignore if destroy doesn't exist
  }

  // Manually remove Lenis classes from HTML element as a safety measure
  if (typeof document !== 'undefined') {
    document.documentElement.classList.remove('lenis', 'lenis-smooth', 'lenis-stopped', 'lenis-scrolling');
    // console.log('%c[Lenis] Removed Lenis classes from HTML', logStyle);
  }

  // Clear the reference so it can be re-created
  _lenis = null;
}

export function pauseLenis() {
  if (!_lenis) return;
  try {
    _lenis.stop();
    // console.log('%c[Lenis] Paused Lenis instance', logStyle);
  } catch (e) {
    // ignore
  }
}

export function unpauseLenis() {
  if (!_lenis) return;
  try {
    _lenis.start();
    // console.log('%c[Lenis] Unpaused Lenis instance', logStyle);
  } catch (e) {
    // ignore
  }
}

export default {
  getLenis,
  startLenis,
  stopLenis,
  pauseLenis,
  unpauseLenis,
};
